import { Box, Dialog, Grid, IconButton } from "@mui/material";
import { SavedBrandContext } from "contexts/SavedBrand";
import { UserRequestsContext } from "contexts/UserRequests";
import { useContext, useState } from "react";
import { CustomEvent } from "schemas/functions";

import { trackEvent } from "utils/tracking";
import { useCollection } from "utils/useCollection";

import UserRequestsList from "../UserRequestsList";
import FavoriteListTabMobile from "./ListHeader/MobileTab";
import styles from "./styles";

enum Tab {
  saved_brand = "saved_brand",
  user_requests = "user_requests",
}

interface Props {
  collections: JSX.Element;
  handleBack: () => void;
  header: JSX.Element;
  footer: JSX.Element;
}

const FavoritesListMobile = ({
  collections,
  handleBack,
  header,
  footer,
}: Props) => {
  const [tab, setTab] = useState<Tab>(Tab.saved_brand);
  const { setOpenSavedBrandsOnMobile, openSavedBrandsOnMobile } =
    useContext(SavedBrandContext);

  const { getTotal } = useCollection();
  const { total: totalRequests } = useContext(UserRequestsContext);
  const total = getTotal();
  const requests = (totalRequests.sent || 0) + (totalRequests.unsent || 0);

  const handleChange = (event: CustomEvent, newValue: Tab) => {
    event.stopPropagation();
    trackEvent("Saved Brand Tab Clicked", { tab: newValue });
    setTab(newValue);
  };

  return (
    <Dialog open={openSavedBrandsOnMobile} fullScreen>
      <Box sx={{ backgroundColor: "white" }}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={styles.header}
        >
          <Grid container justifyContent="flex-start" item xs={10}>
            <IconButton
              onClick={handleBack}
              sx={{ color: "white", fontSize: 13 }}
            >
              <Box component="i" className="fa-regular fa-arrow-left" />
            </IconButton>

            <FavoriteListTabMobile
              label="Saved"
              isActive={tab === Tab.saved_brand}
              total={total}
              handleChange={(e: CustomEvent) =>
                handleChange(e, Tab.saved_brand)
              }
            />
            <FavoriteListTabMobile
              label="Requests"
              total={requests}
              isActive={tab === Tab.user_requests}
              handleChange={(e: CustomEvent) =>
                handleChange(e, Tab.user_requests)
              }
            />
          </Grid>

          <IconButton
            onClick={() => setOpenSavedBrandsOnMobile(false)}
            sx={{ color: "white", fontSize: 13 }}
          >
            <Box component={"i"} className="fa-regular fa-xmark" />
          </IconButton>
        </Grid>

        {tab !== Tab.user_requests && (
          <Grid container sx={styles.mobileContainer} gap={1}>
            {header}
            {collections}
            {footer}
          </Grid>
        )}

        {tab === Tab.user_requests && <UserRequestsList />}
      </Box>
    </Dialog>
  );
};

export default FavoritesListMobile;
